module.exports = __webpack_public_path__ + "static/img/hsem-login.3479c4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hsem-login.png
// module id = YRNS
// module chunks = 2